import Vue from 'vue'

Vue.mixin({
  methods: {
    isNotEmptyObject(obj) {
      return obj && Object.keys(obj).length
    },
    /**
     * This method will generate the html page title based on i18n routes and the params stored in
     * 'ui/breadcrumbParams', creating a meaningful navigation history.
     * In order to pass the params to the i18n  `store.commit('ui/breadcrumbParams', { academyId: params.academyId })`
     */
    buildMetaTitle(matchedRoutes) {
      const breadcrumbParams = this.$store.getters['ui/breadcrumbParams']

      const titleChuncks = matchedRoutes
        .map(matchedRoute => {
          // Ignore "duplicated" routes that Nuxt create to support trailing slash.
          if (matchedRoute.path.endsWith('/')) return null

          const pathWithoutLocalePrefix = matchedRoute.path
            .replace(`/${this.$i18n.locale}/`, '')
            .replace(/^\//, '') // Remove initial slash when path has no locale prefix

          // Uncomment for debugging:
          // console.table({
          //   i18n_path: `routeNames.${pathWithoutLocalePrefix}`,
          //   i18n_params: JSON.stringify(breadcrumbParams),
          //   result: this.$t(`routeNames.${pathWithoutLocalePrefix}`, breadcrumbParams)
          // })

          const titleChuck = this.$t(`routeNames.${pathWithoutLocalePrefix}`, breadcrumbParams)

          // A hack way to ignore missing translations
          if (titleChuck.startsWith('routeNames.')) return null

          return titleChuck
        })
        .filter(Boolean)

      return titleChuncks.join(' › ')
    }
  }
})
